<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox>
        <div slot="body">
            <bita-form ref="form">
                <div slot="body">
                    <bita-formgroup class="row" title="اطلاعات فیش">
                    <bita-input
                        type="text"
                        name="amount"
                        ref="amount"
                        label="مبلغ"
                        rules="required"
                        input-class="form-control"
                        validation-container-class="col-3"
                        subtitle="مبلغ واریز شده"
                        :has-thousand-seprator="true"
                        v-model="gateway.amount"
                    />
                    <bita-input
                        type="text"
                        name="tracking_code"
                        ref="trackingcode"
                        label="کد پیگیری"
                        rules="required"
                        input-class="form-control"
                        validation-container-class="col-3"
                        subtitle=" کد پیگیری"
                        v-model="gateway.tracking_code"
                    />
                    <bita-input
                        type="text"
                        name="card_number"
                        ref="cardnumber"
                        label="واریز به"
                        rules="required"
                        input-class="form-control"
                        validation-container-class="col-3"
                        subtitle="شماره کارت و یا شماره حساب"
                        v-model="gateway.card_number"
                    />
                    <bita-datepicker
                        type="date"
                        id="paymentat"
                        validation-container-class="col-lg-2"
                        name="paymentat"
                        rules="required"
                        label="زمان پرداخت"
                        inputClass="form-control"
                        v-model="gateway.payment_at"
                    />
                    <bita-input
                        type="text"
                        name="user_id"
                        ref="user_id"
                        rules="required|irani"
                        label="واریز به شخص"
                        input-class="form-control"
                        validation-container-class="col-3"
                        @change="findUser"
                        subtitle="کد ملی شخص مورد نظر "
                        v-model.lazy="user_national_code"
                    />
                    <bita-input
                        v-show="user_full_name"
                        type="text"
                        name="user_fullname"
                        ref="user_fullname"
                        label="اطلاعات فرد مورد نظر"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="user_full_name"
                        :disabled="true"
                    />
                    </bita-formgroup>
                    <bita-formgroup class="row" title="اطلاعات ارسال کننده">
                    <bita-input
                        type="text"
                        name="depositor_national_code"
                        ref="depositor_national_code"
                        label="کد ملی واریز کننده"
                        rules="required|irani"
                        input-class="form-control"
                        validation-container-class="col-3"
                        @change="findSenderUser"
                        subtitle="کد ملی واریز کننده"
                        v-model="gateway.depositor_national_code"
                    />
                    <bita-input
                        v-show="depositor_full_name"
                        type="text"
                        name="user_fullname"
                        ref="user_fullname"
                        label="نام و نام خانوادگی واریز کننده"
                        input-class="form-control"
                        validation-container-class="col-3"
                        v-model="gateway.depositor_full_name"
                        :disabled="true"
                    />
                    <bita-input
                        type="text"
                        name="description"
                        ref="description"
                        label="توضیحات"
                        rules="required"
                        input-class="form-control"
                        validation-container-class="col-3"
                        subtitle="توضیحات تکمیلی پرداخت"
                        v-model="gateway.description"
                    />
                    </bita-formgroup>
                </div>
            </bita-form>
            <div slot="footer">
              <bita-bootbutton
                type="success"
                title="پیش نمایش"
                icon="fa fa-book"
                btn-width="150px"
                @click.native="handleView"
              />
            </div>
        </div>
      </bita-ibox>
    </div>
    <form-view
      ref="viewModal"
      :isLoading="isLoadingModal"
      :props-data="gateway"
      :props-user="user_full_name"
      modal-id="view-modal"
      title="تایید نهایی تصویه حساب"
      @on-submit="handleCreate"
    />
  </div>
</template>
<script>
import FormView from './View';
export default {
  components: {FormView},
  data() {
      return {
          breadCrumbs: [
              {title: "صفحه اصلی", link: "/"},
              {title: "تصویه حساب", link: "gateway-transaction"},
          ],
          gateway: {},
          user_national_code: '',
          user_full_name: '',
          depositor_full_name: false,
          user: {},
          isLoadingModal: false,
          updateForm: {},
      }
  },
  methods: {
    findUser() {
      if (this.$ssnIsValid(this.user_national_code)) {
        this.$persistClient("post", "users/find/national-code", {
          national_code: this.user_national_code,
        }).then((res) => {
          const _this = this;
          if (res.data)
            setTimeout(function(){
              _this.user_full_name = res.data.full_name;
              _this.user.id = res.data.id;
            },300)
          else 
            this.user_full_name = '';
        })
      }
    },
    findSenderUser() {
      if (this.$ssnIsValid(this.gateway.depositor_national_code)) {
        this.$persistClient("post", "users/find/national-code", {
          national_code: this.gateway.depositor_national_code,
        }).then((res) => {
          const _this = this;
          setTimeout( function(){
          _this.gateway.depositor_full_name = res.data.full_name;
          _this.depositor_full_name = true;
          },300);
        })
      }else {this.depositor_full_name = false;}
    },
    handleView() {
      this.$refs.form.validate().then((result) => {
        if (result)
          $("#view-modal").modal("toggle");
      })
    },
    handleCreate(e) {
      let data = {
        amount: this.gateway.amount,
        user_id: this.user.id,
        tracking_code: this.gateway.tracking_code,
        card_number: this.gateway.card_number,
        payment_at: this.gateway.payment_at,
        description: this.gateway.description,
        depositor_full_name: this.gateway.depositor_full_name,
        depositor_national_code : this.gateway.depositor_national_code,
      };
      this.$persistClient("post", "gateway-transactions", data)
      .then((res) => {
        this.$izitoast("success", "موفق", res.data.message);
        $("#view-modal").modal("toggle");
        this.reset();
      })
    },
    reset() {
      this.$refs.form.clear();
    }
  }
}
</script>